//
// GraphMetadata.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GTLModel";
import "../data/dynamics/Dynamics";
import "../data/dynamics/DataNameToDataRendererModels";

var GraphMetadata = createModule("gtl::GraphMetadata", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        dynamics: 1,
        dataNameToDataRendererModels: [1],
    },
    ,
    ,
    {
        getDataName: [7,1],
        getDataRendererModels: [1,7],
        addDataNameDataRendererModelPair: [0,7,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default GraphMetadata;
